import {
  EligibleJobStatus,
  EligibleJobStatusApi,
  IEligibleJob,
  IEligibleJobApi,
  IGetEligibleJobsApiResponse,
  IGetEligibleJobsResult,
} from '../types';

const toEligibleJobStatus = (status: EligibleJobStatusApi): EligibleJobStatus => {
  switch (status) {
    case EligibleJobStatusApi.OPEN:
      return EligibleJobStatus.OPEN;
    case EligibleJobStatusApi.PENDING_COUNTER:
      return EligibleJobStatus.PENDING_COUNTER;
    default:
      return EligibleJobStatus.OPEN;
  }
};

const toEligibleJob = (jobApi: IEligibleJobApi): IEligibleJob => {
  return {
    id: jobApi.id,
    status: toEligibleJobStatus(jobApi.status),
    localDate: jobApi.local_date,
    localEndTime: jobApi.local_end_time,
    localStartTime: jobApi.local_start_time,
    localTimezone: jobApi.local_timezone,
    professionName: jobApi.professionName,
    specialty: jobApi.specialty,
  };
};

const toGetEligibleJobsResult = (
  response: IGetEligibleJobsApiResponse,
): IGetEligibleJobsResult => {
  return {
    jobs: response.response.map(toEligibleJob),
    page: response.page,
    limit: response.limit,
    total: response.total,
  };
};

export const EligibleJobAdapter = {
  toEligibleJob,
  toGetEligibleJobsResult,
};
